import { getLinkAction, LinkData } from '../../helpers';
import { ACTION_TYPE, ButtonConfig, ButtonElementDataAttribute } from './getData';

const getAction = (linkData: LinkData): string => (
	`goToDestination(\`${getLinkAction(linkData)}\`);`
);

export default (htmlDocument: Document, buttons: ButtonConfig[]): void => {
	buttons.forEach(({
		isEditedFromBackoffice,
		id,
		isVisible,
		hasLink,
		linkData,
		actionType,
	}) => {
		if (!isEditedFromBackoffice) {
			return;
		}

		const button = htmlDocument.querySelector(`#${id}`) as HTMLDivElement;

		if (hasLink) {
			button.setAttribute(ButtonElementDataAttribute.hasLink, 'true');

			if (linkData) {
				button.dataset[actionType as ACTION_TYPE] = getAction(linkData);
			} else {
				delete button.dataset[actionType as ACTION_TYPE];
			}
		}

		if (isVisible) {
			button.removeAttribute(ButtonElementDataAttribute.hidden);
		} else {
			button.setAttribute(ButtonElementDataAttribute.hidden, 'true');
		}
	});
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/utils/indesignEditor/editableButtons/saveData.ts